import { css } from "styled-components";
import transparentize from "polished/lib/color/transparentize";
import { boldTypographyMixin, textUppercaseMixin } from "../../../../skins/shared/mixins/typography";
const firstLastMarginMixin = css `
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  & > ol,
  & > ul,
  blockquote,
  .table-wrapper {
    /* prevent margins at the top and bottom of the RichText component.
       These should be the responsibility of blade which is utilizing this component to add.
     */
    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
export const riotProductSkin = (chroma, paletteTokens) => css `
  &,
  p,
  li {
    ${chroma.typography.body3};
    color: ${paletteTokens.bladetext1};
  }

  h1,
  h2 {
    ${chroma.typography.body2};
    font-weight: bold;
  }

  h3 {
    ${chroma.typography.body3};
    font-weight: bold;
  }

  h4 {
    ${chroma.typography.body4};
    font-weight: bold;
  }

  h5 {
    ${chroma.typography.body3};
    font-weight: normal;
  }

  h6 {
    ${chroma.typography.body5};
    font-weight: normal;
  }

  /* set vertical margins for headings */
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 1.7em 0 1em;
    text-wrap: balance;
  }

  /* set vertical margins for block level elements */
  p,
  & > ol,
  & > ul,
  pre,
  blockquote,
  figure,
  .table-wrapper {
    margin: ${chroma.spacers.variable.m} 0;
  }

  ul {
    list-style: disc inside;
    padding-left: ${chroma.spacers.variable.m};
    list-style-position: outside;
  }

  ol {
    list-style: decimal inside;
    padding-left: ${chroma.spacers.variable.m};
    list-style-position: outside;
  }

  .table-wrapper {
    width: 100%;
    overflow: auto;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: ${chroma.spacers.constant.l};
  }

  td {
    vertical-align: top;
    background-color: ${transparentize(0.95, paletteTokens.bladebg3)};
  }

  th {
    ${chroma.typography.body5};
    font-weight: 600;
    background-color: ${transparentize(0.9, paletteTokens.bladebg3)};
  }

  td,
  th {
    border: 1px solid ${paletteTokens.keyline};
    padding: 12px 24px;

    ${chroma.mediaQueries.mobileDown} {
      padding: 8px 12px;
    }

    &,
    p,
    li {
      /* text in tables is smaller */
      ${chroma.typography.body5};
    }
  }

  blockquote {
    ${chroma.typography.display6};
    font-weight: bold;
    font-style: italic;
    text-transform: none;
    text-align: center;
  }

  a {
    ${chroma.typography.textLink};
    color: ${paletteTokens.bladetext1};
    text-decoration-color: ${paletteTokens.accents1};

    &:visited,
    &:hover {
      color: ${paletteTokens.accents1};
    }
  }

  figure {
    width: 100%;

    img {
      margin: auto;
    }

    figcaption {
      ${chroma.typography.body5};
      ${boldTypographyMixin};
      ${textUppercaseMixin};
      margin-top: ${chroma.spacers.constant.s};
    }
  }

  p > img,
  blockquote > img {
    display: inline;
  }

  span + span > a > img {
    margin-top: ${chroma.spacers.variable.m};
  }

  ${firstLastMarginMixin}
`;
//# sourceMappingURL=index.js.map